/**
 * Service for getting statistics
 */

import Backend from "../Backend"

class StatsData {

  static fetchDisciplinarianStatistics = function() {
    return Backend.getData(`/api/comp/statistics/disc`)
  }

}

export default StatsData;
